import { ActionsUnion, createAction } from '@om1/platform-utils'

export enum AspenApiActionTypes {
    SET_ASPEN_VERSION = '@@aspenApi/setAspenVersion'
}

export const aspenApiActions = {
    setAspenVersion: (version: string, alembicVersion: string, analyticsDatabase: string) =>
        createAction(AspenApiActionTypes.SET_ASPEN_VERSION, { version, alembicVersion, analyticsDatabase })
}

export type AspenApiActions = ActionsUnion<typeof aspenApiActions>
